import "./topbar.css";
import PropTypes from 'prop-types';
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import ChatIcon from "@mui/icons-material/Chat";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Dropdown } from '@mui/base/Dropdown';
import Divider from '@mui/material/Divider';
import { Menu } from '@mui/base/Menu';
import { MenuButton as BaseMenuButton } from '@mui/base/MenuButton';
import { MenuItem as BaseMenuItem, menuItemClasses } from '@mui/base/MenuItem';
import { styled } from '@mui/system';
import { CssTransition } from '@mui/base/Transitions';
import { PopupContext } from '@mui/base/Unstable_Popup';

import { useState, useContext, useRef, forwardRef } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import CloseFriend from "../closeFriend/CloseFriend";
import axios from "axios"

export default function Topbar() {
  const { user } = useContext(AuthContext);
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const inputElement = useRef();
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;

  const handleLogout = () => {
    localStorage.removeItem("user");
    window.location.reload();
  };

  const autocompleteFunction = async () => {
    if (inputElement.current.value == "") {
      setSearching(false);
    } else {
      setSearching(true);
      const autocompleteRes = await axios.get("https://conexus-api.vercel.app/api/users/autocomplete/" + inputElement.current.value);
      setResults(autocompleteRes.data)
    }
  };

  return (
    <div className="topbarContainer">
      <div className="topbarLeft">
        <Link className="logo" to="https://conexus-br.vercel.app/">
          Conexus
        </Link>
      </div>
      <div className="topbarRight">
        <div className="searchbar">
          <SearchIcon htmlColor="white" className="searchIcon" />
          <input
            placeholder="Search for friend, post or video"
            className="searchInput"
            onChange={autocompleteFunction}
            onFocus={autocompleteFunction}
            onBlur={() => setTimeout(() => setSearching(false), 100)}
            ref={inputElement}
          />
        </div>
        <div className={`autocompleteContainer${searching ? ' show' : ''}`}>
          {searching && results.map((u, idx) => (
            <CloseFriend key={idx} user={u} />
          ))}
          <hr />
        </div>
        <div className="topbarLinks">
          <span className="topbarLink">Homepage</span>
          <span className="topbarLink">Timeline</span>
        </div>
        <div className="topbarIcons">
          <div className="topbarIconItem">
            <PersonIcon />
            <span className="topbarIconBadge">1</span>
          </div>
          <div className="topbarIconItem">
            <ChatIcon />
            <span className="topbarIconBadge">2</span>
          </div>
          <div className="topbarIconItem">
            <NotificationsIcon />
            <span className="topbarIconBadge">1</span>
          </div>
        </div>
        <Dropdown>
          <MenuButton>
            <img
              src={
                user.profilePicture
                  ? PF + "person/" + user.profilePicture
                  : PF + "person/no-avatar.png"
              }
              alt=""
              className="topbarImg"
            />
          </MenuButton>
          <Menu slots={{ listbox: AnimatedListbox }}>
            <MenuItem onClick={() => {}}>Profile</MenuItem>
            <MenuItem onClick={() => {}}>Language settings</MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>Log out</MenuItem>
          </Menu>
        </Dropdown>
      </div>
    </div>
  );
}

const Listbox = styled('ul')(
  ({ theme }) => `
  padding: 6px;
  margin: 12px 0;
  min-width: 200px;
  border-radius: 16px;
  overflow: auto;
  outline: 0px;
  background: #161616;
  z-index: 1;

  .closed & {
    opacity: 0;
    transform: scale(0.95, 0.8);
    transform: translateY(-20px);
    transition: opacity 200ms ease-in, transform 200ms ease-in;
  }
  
  .open & {
    opacity: 1;
    transform: scale(1, 1);
    transform: translateY(0px);
    transition: opacity 100ms ease-out, transform 100ms cubic-bezier(0.43, 0.29, 0.37, 1.48);
  }

  .placement-top & {
    transform-origin: bottom;
  }

  .placement-bottom & {
    transform-origin: top;
  }
  `,
);

const MenuItem = styled(BaseMenuItem)(
  ({ theme }) => `
  list-style: none;
  padding: 8px;
  border-radius: 8px;
  cursor: default;
  user-select: none;
  cursor: pointer;
  margin-bottom: 4px;

  &:last-of-type {
    background: rgba(255, 25, 25, 0.2);
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &.${menuItemClasses.disabled} {
    color: ${theme.palette.mode === 'dark' ? "white" : "white"};
  }
  `,
);

const MenuButton = styled(BaseMenuButton)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  padding: 0;
  color: white;
  transition: all 150ms ease;
  cursor: pointer;
  background: transparent;
  color: ${theme.palette.mode === 'dark' ? "white" : "white"};
  border: none;
  `,
);

const AnimatedListbox = forwardRef(function AnimatedListbox(props, ref) {
  const { ownerState, ...other } = props;
  const popupContext = useContext(PopupContext);

  if (popupContext == null) {
    throw new Error(
      'The `AnimatedListbox` component cannot be rendered outside a `Popup` component',
    );
  }

  const verticalPlacement = popupContext.placement.split('-')[0];

  return (
    <CssTransition
      className={`placement-${verticalPlacement}`}
      enterClassName="open"
      exitClassName="closed"
    >
      <Listbox {...other} ref={ref} />
    </CssTransition>
  );
});

AnimatedListbox.propTypes = {
  ownerState: PropTypes.object.isRequired,
};